import setUserBotRequest from "./requests/set-user-bot-request";
import viewRequest from "./requests/view-request";

const telegramRepository = {
    setUserBot: setUserBotRequest,
    view: viewRequest,
};

export default telegramRepository;
